<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <el-input
            v-model="keywords"
            clearable
            style="width:300px; margin-right:8px;"
          />
        </div>

        <el-button
          type="primary"
          size="mini"
          @click="handleSearch"
        >
          Search
        </el-button>
      </div>
      <div 
        class="action-container"
        style="margin-top:4px;"
      >
        <el-pagination
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div class="button-container">
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleCreate"
          >
            {{ $t('button.create') }}
          </el-button>
        </div>
      </div>
    </template>

    <el-table
      v-loading="isLoading"
      :data="list"
      border
      stripe
    >
      <el-table-column
        label="Name"
        prop="name"
        min-width="180"
      />

      <el-table-column
        label="Ad Name"
        prop="ad_name"
        min-width="180"
      />

      <el-table-column
        label="Marketing U1"
        prop="marketing_u1"
        min-width="100"
      />

      <el-table-column
        prop="image"
        label="Banner Image"
        width="160"
      >
        <template slot-scope="scope">
          <img :src="scope.row.image" width="150"/>
        </template>
      </el-table-column>

      <el-table-column
        label="Date"
        prop="date"
        min-width="100"
      />

      <el-table-column
        :label="$t('table.action')"
        fixed="right"
        align="center"
        width="130"
      >
        <template #default="{ row }">
          <div class="button-group">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="handleEditButtonClick(row)"
            />
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="handleDeleteButtonClick(row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </sticky-header-layout>
</template>

<script>
import useTablePaging from '../../mixins/useTablePaging'

import DealPostService from '../../api/deal-post'

export default {
  name: 'DealPostList',
  mixins: [useTablePaging],
  data() {
    return {
      isLoading: false,
      keywords: '',
      campaignId: '',
      isShowCPCDealPostOnly: false,
      currentFacebookCpcPosts: [],
      currentLinks: [],
      currentImage: '',
      currentMarketingU1: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleCreate() {
      this.$router.push({ path: '/deal-post/create' })
    },
    handleEditButtonClick(row) {
      this.$router.push({ path: `/deal-post/edit/${row.id}` })
    },
    handleDeleteButtonClick(row) {
      this.$confirm(`Confirm Delete?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        this.deleteItem(row.id)
      }).catch(() => {
      })
    },
    handleSearch() {
      this.getList()
    },
    async getList() {
      this.isLoading = true
      this.list = []
      
      try {
        const response = await DealPostService.list(this.keywords, this.isShowCPCDealPostOnly, this.listQuery.page, this.listQuery.size)
        const { data: newList, pagination } = response
        this.list = newList
        this.listQuery.total = parseInt(pagination.total_items, 0)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
      }
    },
    async deleteItem(id) {
      this.isLoading = true

      try {
        const response = await DealPostService.delete(id)

        this.getList()
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.cell {
  overflow: visible;
}

</style>
